(function () {
    'use strict';

    angular.module('app.excel', ['smart-table', 'treeControl', 'ui.bootstrap', 'ngTable']);
})();